export default __webpack_public_path__ + "static/helga-150449823d15122d6d0d537ee812e044.png";